import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";
import OpeningSoon from "./OpeningSoon";

const StartProjects = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Container>
      <section className="py-5 position-relative overflow-hidden">
        {/* Background Image */}
        <img
          src="../assets/projects/ownprojectsbg.png"
          alt="Start Project Background"
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{ objectFit: "cover", zIndex: 0 }}
        />

        {/* Dark Overlay */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundColor: "rgba(0,0,0,0.75)",
            zIndex: 1,
          }}
        />

        {/* Content */}
        <Container className="position-relative d-flex justify-content-center">
          <div
            className="text-white text-center p-5"
            style={{ maxWidth: "900px", zIndex: 2 }}
          >
            <h2 className="wise-secondary-gradient fw-bold mb-3">
              START YOUR OWN PROJECT
            </h2>

            <p className="mb-4">
              Have an idea you're excited about? Apply to initiate a WiSE
              Project by sharing your vision, goals, and the kind of support you
              need to bring it to life. Selected projects receive tailored
              mentorship, resources, and ecosystem support.
            </p>

            <Button variant="primary" className="rounded-2" onClick={() => setShowModal(true)}>
              Apply to start a project
            </Button>
          </div>
        </Container>
      </section>

      <OpeningSoon show={showModal} handleClose={() => setShowModal(false)} />
    </Container>
  );
};

export default StartProjects;
